import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import {Link} from "react-router-dom";
import Form from "react-bootstrap/Form";

import ic_product from "../assets/images/ic_product.svg";
import ic_order from "../assets/images/ic_order.svg";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import {Table} from "react-bootstrap";
import ApiConfig from "../api/ApiConfig";
import {
    DeleteCallWithErrorResponse, PutCallWithErrorResponse, simpleGetCall, simplePostCall,
} from "../api/ApiServices";
import Loading from "../sharedComponents/Loaders/Loading";
import {notifyError, notifySuccess} from "../sharedComponents/notify";
import BtnLoader from "../sharedComponents/Loaders/BtnLoader";
import {PaginationCustomer} from "./PaginationCustomer";


const VendingMachine = () => {
    const {sidebar} = useContext(AppContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [numPages, setNumPages] = useState(1);

    const changePage = (page) => {
        if (page > 0 && page <= numPages) {
            setCurrentPage(page);
        }
    };
    const [show, setShow] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [addValidated, setAddValidated] = useState(false);
    const handleClose = () => setShow(false);
    const handleAddModalClose = () => setShowModalAdd(false);
    const [addVendingMachineData, setAddVendingMachineData] = useState({
        name: "",
        machineId: "",
        location: "",
        latitude: "",
        longitude: "",
        country: "",
        totalRows: 0,
        totalColumn: 0,
        totalSlots: 0,
        deviceType: 1
    });
    const handleShowModalAdd = () => {
        setAddVendingMachineData({
            name: "",
            location: "",
            latitude: "",
            longitude: "",
            country: "",
            totalRows: 0,
            totalColumn: 0,
            totalSlots: 0,
            deviceType: 1
        });
        setShowModalAdd(true);
        setAddValidated(false);
    };

    const [deleteModal, setDeleteModal] = useState({
        show: false, machineId: "",
    });
    const handleDeleteClose = () => setDeleteModal({
        show: false, machineId: "",
    });

    const [VendingEdit, setVendingEdit] = useState(false);
    const handleVendingEditClose = () => setVendingEdit(false);
    const handleVendingEditShow = () => setVendingEdit(true);
    const [validated, setValidated] = useState(false);
    const [vendingMachineList, setVendingMachineList] = useState([]);
    const [loading, setLaoding] = useState(false);

    // GET_ALL_VENDING_MACHINE: BASE_URL + "getallvendingmachine",
    // GET_EDIT_DATA_BY_ID: BASE_URL + "getvendingmachinebyid",
    // UPDATE_VENDING_MACHINE_DATA: BASE_URL + "vendingmahcineupdate",
    // DELETE_VENDING_MACHINE: BASE_URL + "deletevendingmachine",

    // Search func()ty state
    const [searchInput, setSearchInput] = useState("");

    const handleSearchInputChange = (e) => {
        setSearchInput(e.target.value);
    };

    useEffect(() => {
        getAllVendingMachineList();
    }, []);

    // GET_ALL_VENDING_MACHINE
    const getAllVendingMachineList = (page = 1) => {
        setLaoding(true);
        simpleGetCall(ApiConfig.GET_ALL_VENDING_MACHINE + `?page=${page}&size=${perPage}`)
            .then((res) => {
                setLaoding(false);
                if (res.result === true) {
                    setVendingMachineList(res.vendingMachineList || []);
                    setPerPage(res.per_page || 15);
                    setNumPages(res.num_pages || 1);
                    setCurrentPage(res.current_page || 1);
                } else {
                    setVendingMachineList([]);
                    console.log("error response", res);
                }
            })
            .catch((error) => {
                console.log("catch error response,", error);
                setLaoding(false);
            });
    };

    const onChangeHandler = (e) => {
        setVendingMachineData({
            ...vendingMachineData, [e.target.name]: e.target.value,
        });
    };

    const [btnLoading, setBtnLoading] = useState(false);
    const [vendingMachineData, setVendingMachineData] = useState({
        id: 0,
        name: "",
        MachineId: "",
        location: "",
        latitude: "",
        longitude: "",
        country: "",
        totalSlots: 10,
        totalRows: 0,
        totalColumn: 10,
        isDelete: false,
        deviceType: 1
    });


    const getVendingMachineEditData = (machinId) => {
        simpleGetCall(`${ApiConfig.GET_EDIT_DATA_BY_ID}?id=${machinId}`)
            .then((res) => {
                console.log(res);
                // if (res.result === true) {
                let data = res.vendingMachineLists[0];
                console.log("data", data);
                setVendingMachineData({
                    id: data.id,
                    name: data.vendingMachineName,
                    MachineId: data.vendingMachineID,
                    location: data.vendingMachineLocation,
                    latitude: data.latitude,
                    longitude: data.longitude,
                    country: data.country,
                    totalSlots: data.totalSlots ? data.totalSlots : 0,
                    totalRows: data.totalRows ? data.totalRows : 0,
                    totalColumn: data?.totalColumn ? data.totalColumn : 0,
                    isDelete: false,
                    deviceType: data?.deviceType ? data.deviceType : 1
                });
                // }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const updateVendingMachineData = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            vendingMachineData.totalColumn = Number(vendingMachineData.totalColumn);
            vendingMachineData.totalRows = Number(vendingMachineData.totalRows);
            vendingMachineData.totalSlots = Number(vendingMachineData.totalSlots);
            vendingMachineData.deviceType = Number(vendingMachineData.deviceType);
            console.log("Vending Machine data----->", vendingMachineData);
            setBtnLoading(true);
            PutCallWithErrorResponse(ApiConfig.UPDATE_VENDING_MACHINE_DATA, vendingMachineData)
                .then((res) => {
                    console.log(res);
                    if (res.json.result === true) {
                        notifySuccess(res.json.message);
                        setBtnLoading(false);
                        getAllVendingMachineList();
                        handleVendingEditClose();
                        console.log(res);
                    } else {
                        console.log("error response", res);
                        notifyError("Something went wrong");
                        setBtnLoading(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setBtnLoading(false);
                });
        }
        setValidated(true);
    };

    const deleteVendingMachine = (machineId) => {
        DeleteCallWithErrorResponse(`${ApiConfig.DELETE_VENDING_MACHINE}?id=${machineId}`)
            .then((res) => {
                if (res.json.result === true) {
                    notifySuccess(res.json.message);
                    getAllVendingMachineList();
                    handleDeleteClose();
                } else {
                    console.log("error response", res);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const clearVendingMachineData = (machineId) => {
        simplePostCall(`${ApiConfig.CLEAR_VENDING_MACHINE_DATA}?machineid=${machineId}`)
            .then((res) => {
                console.log("res", res);
                if (res.success === true) {
                    notifySuccess(res.message);
                    getAllVendingMachineList();
                    // handleDeleteClose();
                } else {
                    notifySuccess(res.message);
                    console.log("error response", res);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const addVendingMachine = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            let reqBody = JSON.stringify({
                Name: addVendingMachineData.name,
                MachineId: addVendingMachineData.machineId,
                Location: addVendingMachineData.location,
                Latitude: addVendingMachineData.latitude,
                Longitude: addVendingMachineData.longitude,
                Country: addVendingMachineData.country,
                TotalRows: Number(addVendingMachineData.totalRows),
                TotalColumn: Number(addVendingMachineData.totalColumn),
                TotalSlots: Number(addVendingMachineData.totalSlots),
                DeviceType: Number(addVendingMachineData.deviceType),
            });
            console.log("Add Vending Machine data----->", reqBody);
            setBtnLoading(true);
            simplePostCall(ApiConfig.ADD_VENDING_MACHINE, reqBody)
                .then((res) => {
                    if (res.result === true) {
                        notifySuccess(res.message);
                        handleAddModalClose();
                        setBtnLoading(false);
                        getAllVendingMachineList();
                    } else {
                        console.log("error response", res);
                        notifyError("Something went wrong");
                        setBtnLoading(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setBtnLoading(false);
                });
        }
        setAddValidated(true);
    };

    return (<main
        id="cx-main"
        className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
        <div className="heading-btn-main">
            <div className="heading-common">
                <label htmlFor="">VENDING MACHINES</label>
            </div>
            {/* <div className="add-btn">
          <button onClick={handleShow}>
            Add Vending Machine
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div> */}
        </div>

        <Modal
            show={deleteModal.show}
            onHide={handleDeleteClose}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="delete-msg text-center">
                    <label htmlFor="">Do you want to delete?</label>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <div className="buttons-modal    ">
                    <button
                        className="me-2 "
                        type="submit"
                        style={{backgroundColor: "red"}}
                        onClick={() => deleteVendingMachine(deleteModal.machineId)}
                    >
                        Delete
                    </button>
                    <Link to="#" className="" onClick={handleDeleteClose} type="button">
                        Cancel
                    </Link>
                </div>
            </Modal.Footer>
        </Modal>

        <Modal
            show={VendingEdit}
            onHide={handleVendingEditClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Update Vending Machine</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form
                    noValidate
                    validated={validated}
                    onSubmit={updateVendingMachineData}>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Name</Form.Label>
                            <Form.Control
                                name="name"
                                required
                                type="text"
                                value={vendingMachineData?.name ? vendingMachineData.name : ""}
                                onChange={onChangeHandler}
                                disabled={!vendingMachineData.MachineId}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Name.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Group controlId="formDeviceType">
                                <Form.Label column={'sm'}>Device Type</Form.Label>
                                <Form.Select
                                    value={vendingMachineData.deviceType}
                                    onChange={(e) => setVendingMachineData({
                                        ...vendingMachineData,
                                        deviceType: Number(e.target.value)
                                    })}
                                >
                                    <option value={1}>Lock Type Device</option>
                                    <option value={2}>Motor Type Device</option>
                                    <option value={3}>Compatible</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Country</Form.Label>
                            <Form.Control
                                name="country"
                                required
                                type="text"
                                value={vendingMachineData?.country ? vendingMachineData.country : ""}
                                onChange={onChangeHandler}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Name.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Location</Form.Label>
                            <Form.Control
                                name="location"
                                required
                                type="text"
                                value={vendingMachineData?.location ? vendingMachineData.location : ""}
                                onChange={onChangeHandler}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Location
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Latitude</Form.Label>
                            <Form.Control
                                name="latitude"
                                required
                                type="text"
                                value={vendingMachineData?.latitude ? vendingMachineData.latitude : ""}
                                onChange={onChangeHandler}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Latitude
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Longitude</Form.Label>
                            <Form.Control
                                name="longitude"
                                required
                                type="tel"
                                value={vendingMachineData?.longitude ? vendingMachineData.longitude : ""}
                                onChange={onChangeHandler}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Longitude
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Machine Id</Form.Label>
                            <Form.Control
                                name="location"
                                type="text"
                                value={vendingMachineData?.MachineId ? vendingMachineData.MachineId : ""}
                                onChange={onChangeHandler}
                                disabled
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Total Slot</Form.Label>
                            <Form.Control
                                required
                                name="totalSlots"
                                type="number"
                                value={vendingMachineData.totalSlots}
                                onChange={onChangeHandler}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Total Row.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Row</Form.Label>
                            <Form.Control
                                name="totalRows"
                                required
                                type="number"
                                value={vendingMachineData.totalRows}
                                onChange={onChangeHandler}
                                // onChange={(e) => {
                                //     if (e.target.value <= 7) {
                                //         onChangeHandler(e)
                                //     } else {
                                //         notifyError('Please Enter Max 7 Rows')
                                //     }
                                // }}
                                disabled={!vendingMachineData.MachineId}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Total Row.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={'sm'}>Column</Form.Label>
                            <Form.Control
                                name="totalColumn"
                                required
                                type="number"
                                value={vendingMachineData.totalColumn}
                                onChange={onChangeHandler}
                                // onChange={(e) => {
                                //     if (e.target.value <= 10) {
                                //         onChangeHandler(e)
                                //     } else {
                                //         notifyError('Please Enter Max 10 Column')
                                //     }
                                // }}
                                disabled={!vendingMachineData.MachineId}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Total Column.
                            </Form.Control.Feedback>
                        </div>

                    </div>
                    <div className="buttons-modal border-top pt-3 text-end ">
                        <button className="me-2"
                                type="submit"
                                disabled={btnLoading}>
                            {btnLoading ? <BtnLoader/> : "Save"}
                        </button>
                        <Link to="#" onClick={handleVendingEditClose} type="button">
                            Cancel
                        </Link>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <Modal
            show={showModalAdd}
            onHide={handleAddModalClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Add Vending Machine</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form
                    noValidate
                    validated={addValidated}
                    onSubmit={addVendingMachine}
                >
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Name</Form.Label>
                            <Form.Control
                                name="name"
                                required
                                type="text"
                                value={addVendingMachineData?.name}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, name: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Name.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Group controlId="formDeviceType">
                                <Form.Label column={"sm"}>Device Type</Form.Label>
                                <Form.Select
                                    required
                                    value={addVendingMachineData.deviceType}
                                    onChange={(e) => setAddVendingMachineData({
                                        ...addVendingMachineData,
                                        deviceType: Number(e.target.value)
                                    })}
                                >
                                    <option value={1}>Lock Type Device</option>
                                    <option value={2}>Motor Type Device</option>
                                    <option value={3}>Compatible</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Please Device Type.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Country</Form.Label>
                            <Form.Control
                                name="country"
                                required
                                type="text"
                                value={addVendingMachineData?.country}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, country: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Name.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Location</Form.Label>
                            <Form.Control
                                name="location"
                                required
                                type="text"
                                value={addVendingMachineData?.location}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, location: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Location
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Latitude</Form.Label>
                            <Form.Control
                                name="latitude"
                                required
                                type="text"
                                value={addVendingMachineData?.latitude}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, latitude: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Latitude
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Longitude</Form.Label>
                            <Form.Control
                                name="longitude"
                                required
                                type="tel"
                                value={addVendingMachineData?.longitude}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, longitude: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Longitude
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Machine Id</Form.Label>
                            <Form.Control
                                name="machineId"
                                required
                                type="text"
                                value={addVendingMachineData?.machineId}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, machineId: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Machine Id
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>TotalSlots</Form.Label>
                            <Form.Control
                                name="totalSlots"
                                required
                                type="number"
                                value={addVendingMachineData?.totalSlots}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, totalSlots: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Total Row.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Row</Form.Label>
                            <Form.Control
                                name="totalRows"
                                required
                                type="number"
                                value={addVendingMachineData.totalRows}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, totalRows: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Total Row.
                            </Form.Control.Feedback>
                        </div>
                        <div className="col-md-6 mb-3">
                            <Form.Label column={"sm"}>Column</Form.Label>
                            <Form.Control
                                name="totalColumn"
                                required
                                type="number"
                                value={addVendingMachineData.totalColumn}
                                onChange={(e) => setAddVendingMachineData({
                                    ...addVendingMachineData, totalColumn: e.target.value
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please Enter Total Column.
                            </Form.Control.Feedback>
                        </div>
                    </div>
                    <div className="buttons-modal border-top pt-3 text-end ">
                        <button
                            className="me-2"
                            type="submit"
                            disabled={btnLoading}>
                            {btnLoading ? <BtnLoader/> : "Save"}
                        </button>
                        <Link to="#" onClick={handleAddModalClose} type="button">
                            Cancel
                        </Link>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

        <div className="table-wrapper">
            <div className="headerFlex row">
                <div className="innerLabel col-md-4">
                    <label className="labelTxt">
                        Total Records : {vendingMachineList.length}
                    </label>
                </div>
                <div className="col-md-5 d-flex align-items-center">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search By Name..."
                        value={searchInput}
                        onChange={handleSearchInputChange}
                    />
                </div>
                <div className="col-md-3 d-flex align-items-center justify-content-end">
                    <button className="btn btn-primary ms-2" onClick={handleShowModalAdd}>
                        Add Vending Machine
                    </button>
                </div>
            </div>
            {loading ? (<Loading/>) : (<Table striped hover className="display">
                <thead>
                <tr>
                    <th>Sr No.</th>
                    <th>Vending Machine ID</th>
                    <th>Name</th>
                    <th>Location</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {vendingMachineList && vendingMachineList.length > 0 ? (vendingMachineList
                    .filter((item) => {
                        return item.name
                            .toLowerCase()
                            .includes(searchInput.toLowerCase());
                    })
                    .map((machine, i) => {
                        return (<tr key={"vendingMachineList" + i}>
                            <td>{i + 1}</td>
                            <td>{machine.machine_Id}</td>
                            <td>{machine.name}</td>
                            <td>{machine.address}</td>
                            <td className="action" style={{width: "300px"}}>
                                <Link
                                    to="#"
                                    className="icon"
                                    onClick={() => {
                                        handleVendingEditShow();
                                        getVendingMachineEditData(machine.id);
                                        setVendingMachineData({
                                            id: 0,
                                            name: "",
                                            location: "",
                                            latitude: "",
                                            longitude: "",
                                            totalSlots: "",
                                            totalColumn: '',
                                            totalRows: ""
                                        });
                                        setValidated(false);
                                    }}
                                >
                                    <img src={ic_edit} alt=""/>
                                </Link>
                                <Link
                                    className="icon"
                                    to={'/ProductList/' + machine.id}
                                >
                                    <img src={ic_product} alt={'show products'}/>
                                </Link>
                                <Link
                                    className="icon"
                                    to={'/MachineOrders/' + machine.id}
                                >
                                    <img src={ic_order} alt={'show orders'}/>
                                </Link>
                                <Link
                                    to="/StockStatement"
                                    state={machine}
                                    // onClick={() => {
                                    //   navigate("/StockStatement");
                                    // }}
                                    className="icon"
                                >
                                    <img src={ic_eyes} alt=""/>
                                </Link>
                                <Link
                                    to="#"
                                    className="icon"
                                    onClick={() => {
                                        setDeleteModal({
                                            show: true, machineId: machine.id,
                                        });
                                    }}
                                >
                                    <img src={ic_delete} alt=""/>
                                </Link>
                                <Link
                                    to="#"
                                    className="icon text-decoration-none text-light"
                                    onClick={() => {
                                        clearVendingMachineData(machine.machine_Id);
                                    }}
                                >
                                    Clear Data
                                </Link>
                            </td>
                        </tr>);
                    })) : (
                    <tr>
                        <td colSpan="5" style={{textAlign: "center", color: "red"}}>
                            Data Not Found
                        </td>
                    </tr>
                )}
                </tbody>
            </Table>)}
            <div className="d-flex justify-content-end">
                {vendingMachineList && vendingMachineList.length > 0 ? (<PaginationCustomer
                    changePage={changePage}
                    pageCount={numPages}
                    currentPage={currentPage}/>) : (<div>
                    <h5 style={{color: "red"}}> Records Not Found</h5>
                </div>)}
            </div>
        </div>
    </main>);
};

export default VendingMachine;
